import * as providers from "@/providers";
import {IoC} from "atom";
import "normalize.css";

const registerProviders = (container, providers) => {
    Object.keys(providers).forEach(key => {
        const provider = providers[key];
        // pass container to register dependencies
        provider(container);
    });
};

// composition root
export default async function() {
    // create new IoC container for dependency management
    const container = new IoC();

    // load providers locally
    registerProviders(container, providers);

    // now retrieve the application
    await container.app;
}
